import { Client } from "@/Common/Api/Client";
import { LicencedIntervenor } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicencedIntervenor";
import { SearchLicenceResult } from "@/Common/Api/MedfarDictionaries/Dto/Responses/SearchDoctorResults";
import * as ServerOperations from "@/Common/Operations/operations.server";

interface IDoctorSearchAutocomplete {
    onItemSelectCallback: (intervenor: LicencedIntervenor) => void;
    focusOnMount?: boolean;
    searchOnMount?: boolean;
    componentId: string;
    text: string;
    textChangedFunction?: (s: string) => void;
    onBlur?: () => void;
    isValid?: boolean
}

class DoctorSearchAutocompleteState {
    public LicenceResults: LicencedIntervenor[];
    public IsListDisplayed: boolean;
    public Text: string;

    constructor(s: DoctorSearchAutocompleteState = null) {
        if (s != null) {
            this.LicenceResults = s.LicenceResults;
            this.IsListDisplayed = s.IsListDisplayed;
            this.Text = s.Text;
        }
    }

    public static default(searchText: string = ""): DoctorSearchAutocompleteState {
        return new DoctorSearchAutocompleteState({
            LicenceResults: [],
            IsListDisplayed: false,
            Text: searchText
        });
    }
}

class DoctorSearchAutocomplete extends React.Component<IDoctorSearchAutocomplete, DoctorSearchAutocompleteState> {
    private timeoutReferenceBlur: number;
    private timeoutReferenceDoctor: number;

    constructor(props: IDoctorSearchAutocomplete) {
        super(props);
        this.state = DoctorSearchAutocompleteState.default(props.text);
    }

    public render(): JSX.Element {
        var errorClass = this.props.isValid ? "" : " has-error";

        return (
            <div id={"Parentdiv_" + this.props.componentId} className={"doctor-autocomplete" + errorClass}>
                <input id={this.props.componentId} key={this.props.componentId} type="text" className="form-control" onFocus={this.onFocus.bind(this)} onKeyDown={this.keyDown.bind(this)} onClick={this.TrottledExecuteSearch.bind(this, null)} onBlur={this.onBlur.bind(this)} onChange={this.onTextChange.bind(this)} value={this.state.Text} />
                {this.state.IsListDisplayed != false && (
                    <div className="doctor-results-ps">
                        <div id="scroll_container" className="doctor-results-container" style={{ width: "300px" }}>
                            <ul className="doctor-result-list" style={{ borderColor: "solid 1px #F4F6F9" }}>
                                {this.state.LicenceResults.map((x: LicencedIntervenor, i: number) => {
                                    let cssStyle: React.CSSProperties = {};
                                    if (x.IsHighlighted == true)
                                        cssStyle = { backgroundColor: "#e4edfb" };

                                    return (
                                        <li id={"li_doctor_" + i} key={"li_doctor_" + i} onClick={this.selectItem.bind(this, x)}>
                                            <div id={"doctor_" + i} key={"doctor_" + i} className="doctor-result" style={cssStyle}>
                                                <h5>{x.FirstName + ", " + x.LastName + " (" + LicencedIntervenor.GetLicence(x) + ")" + " " + x.OrganisationCode}</h5>
                                                {!IsNullOrWhiteSpace(x.Address) && (
                                                    <p>
                                                        <span>{x.Address}</span>
                                                    </p>
                                                )}
                                                <p>
                                                    <span>{x.Phone}</span>
                                                    {!IsNullOrWhiteSpace(x.Fax) &&
                                                        <span style={{ marginLeft: "17px" }}>{"Fax: " + x.Fax}</span>
                                                    }
                                                </p>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    public componentDidUpdate(prevProps: IDoctorSearchAutocomplete): void {
        if (this.props.text !== prevProps.text) {
            this.setState(DoctorSearchAutocompleteState.default(this.props.text));
        }
    }

    public componentDidMount(): void {
        var self = this;

        if (this.props.focusOnMount == true) {
            window.setTimeout(() => $("#" + self.props.componentId).focus(), 500);
        }

        if (this.props.searchOnMount == true && this.props.text != "") {
            this.TrottledExecuteSearch(0);
        }
    }

    public componentWillUnmount(): void {
        this.clearBlurTimeOut();
    }

    private onFocus(): void {
        var self = this;

        if (this.state.LicenceResults.length > 0 && !this.state.IsListDisplayed) {
            var s = new DoctorSearchAutocompleteState(this.state);
            s.IsListDisplayed = true;
            this.setState(s);
        }

        window.setTimeout(() => $("#" + self.props.componentId).select(), 50);
    }

    public onBlur(): void {
        this.clearBlurTimeOut();
        this.timeoutReferenceBlur = window.setTimeout(() => {
            this.mutateState(s => s.IsListDisplayed = false);
        }, 350);

        this.props.onBlur?.();
    }

    public mutateState(mutation: (d: DoctorSearchAutocompleteState) => void, then: () => void = null): void {
        var s = new DoctorSearchAutocompleteState();
        mutation(s);
        if (then != null)
            this.setState(s, then);
        else
            this.setState(s);
    }

    private keyDown(e: React.KeyboardEvent): void {
        // up
        if (e.keyCode === 38) { e.preventDefault(); this.MoveSelectionUpOrDown(true); }

        // down
        if (e.keyCode === 40) { e.preventDefault(); this.MoveSelectionUpOrDown(false); }

        // enter
        if (e.keyCode === 13) { this.selectItem(this.state.LicenceResults[this.indexOfSelectedItem()]); }

        // escape
        if (e.keyCode === 27) {
            var s = new DoctorSearchAutocompleteState(this.state);
            s.IsListDisplayed = false;
            this.setState(s);
        }
    }

    private MoveSelectionUpOrDown(IsDirectionUp: boolean): void {
        let self = this;

        if (this.state.LicenceResults == null)
            return;

        var collection = this.state.LicenceResults;
        if (collection.length == 0)
            return;

        var idx = this.indexOfSelectedItem();
        if (idx === -1) { // None selected
            collection.forEach(x => x.IsHighlighted = false);
            collection[IsDirectionUp ? collection.length - 1 : 0].IsHighlighted = true;
            this.mutateState(s => s.LicenceResults = collection, () => self.AdjustScroll());
            return;
        }

        // Top or bottom of list
        if ((idx === 0 && IsDirectionUp) || (idx === collection.length - 1 && !IsDirectionUp))
            return;

        collection[idx].IsHighlighted = false;
        idx = idx + (IsDirectionUp ? -1 : 1);

        collection[idx].IsHighlighted = true;
        this.mutateState(s => s.LicenceResults = collection, () => self.AdjustScroll());
    }

    public AdjustScroll(): void {
        var idx = this.indexOfSelectedItem();

        let scrollParent = $("#scroll_container");
        let liSelected = $("#li_doctor_" + idx);
        let firstItem = $("#li_doctor_" + 0);
        if (scrollParent != null && liSelected != null && firstItem != null) {
            let scrollParentHeight = scrollParent.height();
            let CurrentScrollPosition = Math.abs(firstItem.position().top);

            let selectedItemRelativePosition = liSelected.position().top; // relative to CurrentScrollPosition
            let selectedItemHeight = liSelected.height();

            if (selectedItemRelativePosition < 0) // Item is above scoll position
                scrollParent.scrollTop(CurrentScrollPosition + selectedItemRelativePosition);
            else if (selectedItemRelativePosition + selectedItemHeight > scrollParentHeight) // Item is below scroll
                scrollParent.scrollTop(CurrentScrollPosition + (selectedItemRelativePosition + selectedItemHeight - scrollParentHeight)); // Add the offset to scroll position in order to fully include the last item
        }
    }

    private indexOfSelectedItem(): number {
        if (this.state.LicenceResults == null || this.state.LicenceResults.length == 0)
            return -1;

        for (var i = 0; i < this.state.LicenceResults.length; i++) {
            var item = this.state.LicenceResults[i];
            if (item.IsHighlighted == true) {
                return i;
            }
        }
        return -1;
    }

    private onTextChange(e: React.ChangeEvent<HTMLInputElement>): void {
        var val = e.target.value;
        var s = new DoctorSearchAutocompleteState(this.state);
        s.Text = val;
        var self = this;
        this.setState(s, () => {
            if (self.state.Text == "") {
                self.selectItem(null);
            }
            else
                self.TrottledExecuteSearch.apply(self, []);
        });

        if (this.props.textChangedFunction != null) {
            this.props.textChangedFunction(val);
        }
    }

    private selectItem(item: LicencedIntervenor): void {
        var self = this;

        var s = new DoctorSearchAutocompleteState(this.state);
        s.Text = (item == null) ? "" : item.LastName + " " + item.FirstName;
        s.IsListDisplayed = false;

        this.setState(s, () => { self.props.onItemSelectCallback(item); });
    }

    private TrottledExecuteSearch(selectedIndex?: number): void {
        var self = this;

        // Throlle
        if (this.timeoutReferenceDoctor !== -1) {
            clearTimeout(this.timeoutReferenceDoctor);
            this.timeoutReferenceDoctor = -1;
        }
        this.timeoutReferenceDoctor = window.setTimeout(() => {
            self.ExecuteSearch(selectedIndex);
        }, 250);
    }

    public ExecuteSearch(selectedIndex?: number): void {
        var self = this;
        if (IsNullOrWhiteSpace(self.state.Text) || cacheStore.Helper.RemoveDiacritics(self.state.Text).length < 2)
            return;

        var client = new Client();
        client.Post(apiSettings.buildApiPath(), ServerOperations.Server.MedfarDictionnary_SearchDoctors, { SearchString: self.state.Text, StateLookUpId: sessionStore.getCurrentEmployeeActiveSiteStateLookUpId() }, response => {
            var results: SearchLicenceResult = response;
            const patientContactId = patientStore.getCurrentPatientContactId();
            const intervenorsOnFile = patientStore.PatientProfileCliniciansModels?.[patientContactId]
                ?.get("IntervenorsOnFile")
                ?.toArray() ?? [];
            if (self.state.Text == results.SearchText) {
                var s = new DoctorSearchAutocompleteState(this.state);
                const listIntervenorsOnFileIds = intervenorsOnFile.map(p => p.Model.LicencedIntervenor).filter(p => p).map(p => p.Id);
                const searchLicencedIntervenorsResults = results.SearchLicenceResults.filter(p => !listIntervenorsOnFileIds.includes(p.Id));

                s.LicenceResults = searchLicencedIntervenorsResults
                    .map(e => new LicencedIntervenor({
                        ...e,
                        OrganisationCode: cacheStore.AllLicenseOrganizationRulesById[e.LicenceOrganisationRuleId].OrganisationCode
                    }));
                // clone

                if (searchLicencedIntervenorsResults.length > 0) {
                    if (selectedIndex != null) {
                        self.selectItem(results.SearchLicenceResults[selectedIndex]);
                    }
                    else {
                        s.IsListDisplayed = true;
                    }
                }

                self.setState(s);
            }
        }, error => { console.error(error); });
    }

    private clearBlurTimeOut(): void {
        if (this.timeoutReferenceBlur !== -1) {
            clearTimeout(this.timeoutReferenceBlur);
            this.timeoutReferenceBlur = -1;
        }
    }
}

export { DoctorSearchAutocomplete };
